import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'
import ProfilePicture from 'components/profile/profile-picture'
import { loginUser, saveAccount, changeTitle } from 'state/actions'
import { withRouter } from 'react-router'
import Button from 'components/button/button'
import copy from 'fast-copy'
import Icon from 'components/icon/icon'
import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import Checkbox from 'components/input/checkbox'
import InputStandard from 'components/input/standard'

import SmoothCollapse from 'react-smooth-collapse'

import { isValidFile } from 'utils/file'

import yup from 'yup'

class RegisterAccount extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isLoading: false,
			accountName: '',
			allowDomainSuggestion: false,
			showDomainSuggestion: false,
			saveSuccess: false,
			error: null,
			validateResponse: null,
			imageFile: '',
			imagePreviewUrl: '',
			domain: '',
			id: null
		}
	}

	UNSAFE_componentWillMount = _ => {
		const {
			isCreateNew,
			isNew,
			accountData,
			changeTitle
		} = this.props

		if (isCreateNew) {
			// might be a cleverer way of checking whether the domain's available
			this.setState({
				allowDomainSuggestion: false
			})
		} else if (!isNew) {
			this.setState({
				accountName: accountData.name,
				id: accountData.id,
				imagePreviewUrl: accountData.image_url,
				allowDomainSuggestion: !!accountData.authorised_domain
			})
		} else {
			changeTitle('Register account')
		}
	}

	componentDidMount() {
		const {
			userData,
			hideDomainSuggestion,
			accountData
		} = this.props

		if (userData.email && !hideDomainSuggestion) {
			if (accountData && accountData.authorised_domain) {
				this.setState({
					domain: accountData.authorised_domain,
					showDomainSuggestion: true
				})

				return;
			}

			const domain = userData.email.replace(/.*@/, '')

			const blacklistedDomainPatterns = [
				"@gmail.",
				"@yahoo.",
				"@live.",
				"@msn.",
				"@outlook.",
				"@hotmail.",
				"@bigpond.",
				"@mail.",
				"@gmx.",
				"@icloud.",
				"@aol.",
				"@yandex."
			];

			let showDomainSuggestion = true

			blacklistedDomainPatterns.forEach(pattern => {
				if (userData.email.toLowerCase().includes(pattern)) {
					showDomainSuggestion = false
				}
			});

			if (showDomainSuggestion) {
				this.setState({
					domain: domain,
					showDomainSuggestion: showDomainSuggestion
				})
			}
		}
	}

	componentDidUpdate = prevProps => {
		if(this.props.isActive && !prevProps.isActive && this.inputRef){
			this.inputRef.focus()
		}
	}

	handleChange = (event, input) => {
		if(event.target.value.length > 120){
			// stop people putting massive strings in.
			return 
		}

		let currentState = copy(this.state)

		currentState[input] = event.target.value

		if (input === 'domain' && !event.target.value) {
			currentState.allowDomainSuggestion = false
		}

		this.setState({
			...currentState,
		})
	}

	handleAllowDomainChange = (isChecked, domain) => {
		this.setState({
			allowDomainSuggestion: isChecked,
			domain: domain,
		})

		if (isChecked && this.domainInput) {
			this.domainInput.inputRef.focus()
		}
	}

	handleImageChange = e => {
		let reader = new FileReader()
		let file = e.target.files[0]

		if (!file) {
			return
		}

		const validityCheck = isValidFile(file, 'image', 1)

		if (file && validityCheck.isValid) {
			reader.onloadend = _ => {
				this.setState({
					imageFile: file,
					imagePreviewUrl: reader.result,
				})
			}

			reader.readAsDataURL(file)
		} else if (!validityCheck.isValid) {
			return this.props.handleError(validityCheck.response)
		}
	}

	handleSubmit = async _ => {
		const {
			affiliate
		} = this.props

		// Account name schema
		const accountSchema = yup.object().shape({
			accountName: yup.string().required('Please enter an organization name'),
		});

		const emailSchema = yup.object().shape({
			domain: yup.string().email('That domain doesn\'t seem valid.').required()
		});

		let requestData = {
			...this.state,
			user_id: this.props.userData.id,
		}

		if(affiliate){
			requestData.affiliate_id = affiliate.id
		}

		// Run input fields against schema
		try {
			await accountSchema.validate({ ...this.state })
		} catch (error) {
			return this.props.handleError(error.message)
		}

		// create a 'valid' email from the domain, to let yup validate.
		if (this.state.allowDomainSuggestion) {
			let testDomain = 'a@' + this.state.domain;

			try {
				await emailSchema.validate({ domain: testDomain });
			} catch (error) {
				return this.props.handleError('That domain doesn\'t seem valid');
			}
		} else {
			delete requestData['domain'];
		}

		this.setState({
			isLoading: true,
		})

		this.props.saveAccount(requestData, (error, response) => {
			if (error) {
				console.log(error)
				return this.props.handleError(error.message)
			}

			if (response.status === 200) {
				this.setState({
					showResponse: true,
					responseMessage: 'Success!',
					responseIcon: 'check',
				})

				setTimeout(_ => {
					const {
						isNew,
						isCreateNew,
						hasNext,
						loginUser,
						loginCredentails,
						userData,
						history,
						goToBilling,
						goToApp,
						closeCallback
					} = this.props
					
					this.setState({
						showResponse: false,
						isLoading: false,
					})

					if (isNew) {
						loginUser(loginCredentails, _ => {
							this.setState({
								isLoading: false,
							})

							if(hasNext){
								return goToBilling()
							}

							if (userData) {
								return goToApp()
							}
						})
					} else {
						if(isCreateNew){
							history.push('/'+response.data.slug)

							closeCallback()
						}
					}
				}, 1000)
			}
		})
	}
	render() {
		const {
			validateResponse,
			isNew,
			handleDismiss,
			isCreateNew,
			goBack,
			closeCallback
		} = this.props

		const {
			isLoading,
			showResponse,
			responseIcon,
			responseMessage,
			imagePreviewUrl,
			accountName,
			showDomainSuggestion,
			allowDomainSuggestion,
			domain
		} = this.state

		let formClass = 'register-container auth-fields'

		if (isLoading) {
			formClass += ' loading'
		}

		let responseExpanded = false

		if (validateResponse) {
			responseExpanded = true
		}

		return (
			<form
				className={formClass}
				onSubmit={e => { e.preventDefault() }}
				onClick={_ => {
					if (window.Keyboard && window.Keyboard.hide) {
						window.Keyboard.hide()
					}
				}}>
				{showResponse ? (
					<div className="response-container">
						<Icon name={responseIcon} />
						<span>{responseMessage}</span>
					</div>
				) : (
						<Loader visible={isLoading} />
					)}
				<div className="form-fields">
					<div className="left">
						<ProfilePicture 
							forceLight={isNew} 
							account={true} 
							handleImageChange={this.handleImageChange} 
							editable={true} 
							url={imagePreviewUrl} 
						/>
					</div>
					<div className="right">
						<div className="form-row">
							<input 
								onClick={e => { e.stopPropagation() }} 
								onChange={e => { this.handleChange(e, 'accountName') }} 
								value={accountName} 
								type="text" 
								placeholder="Organization name" 
								ref={ref => this.inputRef = ref}
							/>
						</div>
						<SmoothCollapse expanded={responseExpanded}>
							<ValidateResponse 
								dismissCallback={handleDismiss} 
								response={validateResponse} 
								timeout={5000} 
							/>
						</SmoothCollapse>
						{showDomainSuggestion && (
							<div className="form-row">
								<label 
									className="domain-toggle" 
									onClick={e => e.stopPropagation()}
								>
									<Checkbox 
										isChecked={allowDomainSuggestion} 
										onChange={isChecked => { this.handleAllowDomainChange(isChecked, domain) }} 
									/>
									{ isNew ?
										<span>
											Allow anyone with an <em>'@{domain}'</em> email to join?
										</span>
										:
										<span>
											Allow anyone to register from this email domain:
											<span>
												<span>@</span>
												<InputStandard 
													outlineOnFocus={false} 
													ref={ref => this.domainInput = ref}
													callback={null} 
													value={domain} 
													onChange={e => { this.handleChange(e, 'domain') }} 
												/>
											</span>
										</span>
									}
								</label>
							</div>
						)}
						<Button 
							size={'big'} 
							level={'high'} 
							callback={this.handleSubmit} 
							label={(isNew || isCreateNew) ? 'Save details' : 'Update account'} 
							icon={'check'} 
						/>
						{ isNew ?
							<Button 
								size={'big'} 
								level={'low'} 
								callback={goBack} 
								label={'Go back'} 
								icon="angle-left" 
							/>
							:
							<Button 
								size={'big'} 
								level={'low'} 
								callback={closeCallback} 
								label={'Cancel'} 
							/>
						}
					</div>
				</div>
			</form>
		)
	}
}

const mapStateToProps = state => {
	return {
		allAccounts: state.account.entities.accounts,
	}
}

export default withRouter(connect(mapStateToProps, { saveAccount, loginUser, changeTitle })(withValidateResponse(RegisterAccount)))
